/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MapperConfigEditor.vue?vue&type=template&id=5e315d3a&scoped=true"
import script from "./MapperConfigEditor.vue?vue&type=script&lang=js"
export * from "./MapperConfigEditor.vue?vue&type=script&lang=js"
import style0 from "./MapperConfigEditor.vue?vue&type=style&index=0&id=5e315d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e315d3a",
  null
  
)

export default component.exports